import { assertExists, groupArrayBy, sortByDateRange } from '@/utils/general'
import { uniqBy } from 'lodash'

const mergeAltCurrency = (price, filteredArray) => {
  return filteredArray.map(obj => {
    /* istanbul ignore else */
    if (!price.currency_alt || price.currency_alt.total === 0) return obj

    const alt = price.currency_alt.components.find(
      ex => ex.object_id === obj.object_id
    )
    return { ...obj, currency_alt: alt }
  })
}

export default {
  computed: {
    getMandatoryExtrasPriceZero() {
      /* istanbul ignore else */
      if (!this.price.components) return false

      const filtered = this.price.components.filter(
        component =>
          component.extra_fields !== null &&
          component.object_type !== 'person' &&
          component.extra_fields.is_mandatory &&
          component.price === 0 &&
          component.days != 0 && 
          (component.extra_fields.billing_type === 'included' || component.extra_fields.billing_type === 'on_site')
      )

      const mapped = mergeAltCurrency(this.price, filtered)
      return mapped.length > 0 ? uniqBy(mapped, 'object_id') : false
    },

    getMandatoryExtrasPriceNotZero() {
      /* istanbul ignore else */
      if (!this.price.components) return false

      const filtered = this.price.components
      .filter(
        component =>
          component.extra_fields !== null &&
          component.object_type !== 'person' &&
          component.extra_fields.is_mandatory
          //  && (component.extra_fields.billing_type !== 'included' && component.extra_fields.billing_type !== 'on_site')
      )
      .map(component => ({
        ...component,      
        period_range: component.choice_period_from && component.choice_period_until
          ? `${component.choice_period_from}|${component.choice_period_until}|choice`
          : `${component.period_from}|${component.period_until}|`,
      }))

      const mapped = mergeAltCurrency(this.price, filtered)
      return mapped.length > 0 ? mapped : false
    },
    
    getMandatoryExtrasPriceNotZeroBySeason() {
      if (!Array.isArray(this.getMandatoryExtrasPriceNotZero) || this.getMandatoryExtrasPriceNotZero.length === 0) {
        return false;
      }
    
      const sortedExtras = sortByDateRange(this.getMandatoryExtrasPriceNotZero, 'period_range')
      return groupArrayBy(sortedExtras, "period_range");
    },

    getGuestBySeason() {
      /* istanbul ignore else */
      if (!this.price.components) return false

      const filteredPersons = this.price.components
      .filter(
        component =>
          component.extra_fields === null && component.object_type === 'person'
      )
      .map(component => ({
        ...component,       
        period_range: component.choice_period_from && component.choice_period_until
          ? `${component.choice_period_from}|${component.choice_period_until}|choice`
          : `${component.period_from}|${component.period_until}|`,
      }))

      const sortedPersons = sortByDateRange(filteredPersons, 'period_range')

      return sortedPersons.length > 0
        ? groupArrayBy(sortedPersons, 'period_range')
        : false
    },

    getUserExtrasBySeasons() {
      /* istanbul ignore else */
      if (!this.price.components) return false

      const filteredExtras = this.price.components
      .filter(
        component =>
          component.extra_fields !== null &&
          component.object_type !== 'person' &&
          !component.extra_fields.is_mandatory
      ) 
      .map(component => ({
        ...component,
        period_range: component.choice_period_from && component.choice_period_until
          ? `${component.choice_period_from}|${component.choice_period_until}|choice`
          : `${component.period_from}|${component.period_until}|`,
      }))
      const sortedExtras = sortByDateRange(filteredExtras, 'period_range')

      return sortedExtras.length > 0 ? groupArrayBy(sortedExtras, 'period_range') : false
    },

    getUserCampsites() {
      /* istanbul ignore else */
      if (!this.price.components) return false
      const filteredCampsites = this.price.components
      .filter(
        component => component.object_type === 'campsite'
      )
      .map(component => ({
        ...component,        
        period_range: component.choice_period_from && component.choice_period_until
          ? `${component.choice_period_from}|${component.choice_period_until}|choice`
          : `${component.period_from}|${component.period_until}|`,
        }))

      return filteredCampsites.length > 0
        ? groupArrayBy(filteredCampsites, 'period_range')
        : false
    },
  },
  mounted() {
    /** test if variables used in this mixin exist in the context the component **/
    assertExists('price', this)
  },
}
